module.exports = __webpack_public_path__ + "img/jaoc_pop_firstplaceteam_trophy.338ce385.png";